export async function getCurrentPosition(input) {
    const position = await input.platformServices.getCurrentPosition();
    return position;
}
